import angular from 'angular';

import EventDetailsModalComponent from './event-details-modal.cmpt';

export default angular
    .module('application.component.modals.component.event-details-modal', [])
    .component(EventDetailsModalComponent.selector, EventDetailsModalComponent);



// WEBPACK FOOTER //
// ./src/application/component/modals/component/event-details-modal/index.js